export default __webpack_public_path__ + "static/media/nav-baskt-icon.91526328.svg";